import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-keyboard',
  templateUrl: './keyboard.component.html',
  styleUrls: ['./keyboard.component.scss'],
  standalone: false
})
export class KeyboardComponent {

  @Input() pin: string = '';
  @Output() pinChange = new EventEmitter<string>();

  @Output() pinLengthFour = new EventEmitter<void>();
  @Output() leave = new EventEmitter<void>();

  pinView: string = '';


  /**
   * Presionar número
   *
   */
  pressNumber(number: number) {
    this.pin += number;
    this.pinView += '*';

    this.pinChange.emit(this.pin);

    if (this.pin.length === 4) {
      this.pinLengthFour.emit();
      setTimeout(() => this.deletePin(), 100);
    }
  }


  /**
   * Borrar pin
   *
   */
  deletePin() {
    this.pin = '';
    this.pinView = '';

    this.pinChange.emit(this.pin);
  }


  /**
   * Salir
   *
   */
  exit() {
    this.deletePin();
    this.leave.emit();
  }

}
